// ** Type Imports
import type { OwnerStateThemeType } from '.';
import type { Skin } from '../../types';

const Autocomplete = (skin: Skin) => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          paddingTop: '6.5px',
          paddingBottom: '6.5px',
        },
        paper: ({ theme }: OwnerStateThemeType) => ({
          backdropFilter: 'blur(30px)',
          ...(skin === 'bordered' && {
            boxShadow: 'none',
            border: `1px solid ${theme.palette.divider}`,
          }),
        }),
      },
    },
  };
};

export default Autocomplete;
